import React from 'react';

import { useUserContext } from 'providers/UserProvider';

import Table from 'components/common/Table';

import { grnApi } from 'api';

import {
  getGrnListTab,
  getGrnListColumns,
  GRN_FILTER_OPTIONS,
} from 'constants/grn';

const Grn = () => {
  const { selectedTenant, selectedWarehouse } = useUserContext();

  const tenant = selectedTenant?.domains?.[0]?.domain;
  const warehouse = selectedWarehouse?.domain;
  const initialFilter = { warehouse: selectedWarehouse?.id };

  return (
    <Table
      title="GRN List"
      apiService={grnApi}
      sortable={true}
      columns={getGrnListColumns(tenant, warehouse)}
      filterOptions={GRN_FILTER_OPTIONS}
      tabOptions={getGrnListTab(initialFilter)}
      initialFilter={initialFilter}
    />
  );
};

export default Grn;
